// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { get } from "@insite/client-framework/Services/ApiService";

export interface EventDetailsModel {
    UpcomingDates: UpcomingDateResult[];
    ProductNumber: string;
    ProductId: string;
    CanAddToCart: boolean;
    EventUrl: string;
}

export interface UpcomingDateResult {
    Date: string;
    Time: string;
    Location: string;
    Url: string;
}

export interface EventDetailsResponse {
    StatusCode: number;
    Result: EventDetailsModel;
}

export async function getEventDetails(pageId: string) {
    const result = await get<EventDetailsResponse>(`api/wes/TrainingCalendar/${pageId}`);
    return result;
}
